import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { domainApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';
import type { DomainFormData } from '../types/domain';

export function useDomains() {
  return useQuery({
    queryKey: queryKeys.domains.list(),
    queryFn: () => domainApi.listDomains(),
  });
}

export function useUpdateDomain() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: DomainFormData }) =>
      domainApi.updateDomain(id, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.domains.list() }),
  });
}
